import React, { type PropsWithChildren } from "react";

import { GenericTooltip } from "@components/tooltip-container";

import { type Filter } from "./filter-pill";

interface Props {
  filters: Filter[];
}

export const MorePill = ({ filters }: Props) => {
  return (
    <Tooltip filters={filters}>
      <div className="text-[9px] bg-interstellar-3 rounded-2xl px-3 flex items-center h-[30px]">
        + {filters.length} MORE
      </div>
    </Tooltip>
  );
};

export const Tooltip = ({ filters, children }: PropsWithChildren<Props>) => {
  return (
    <GenericTooltip
      noInfoCircle
      mouseEnterDelay={0.3}
      placement="bottom"
      content={
        <div className="text-xs">
          {filters.map(({ breakdown, values, total }) => (
            <div key={breakdown} className="mb-3.5 last:mb-0">
              <div className="text-xxs text-gray+2 mb-2 pr-3">
                {breakdown} ({values.length} of {total})
              </div>
              <div className="text-xs grid grid-cols-2 gap-x-2 gap-y-0.5">
                {values.map((value) => (
                  <div key={value} className="mb-0.5 last:mb-0">
                    {value}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      }
    >
      {children}
    </GenericTooltip>
  );
};
